import { render, staticRenderFns } from "./ConfirmTermsOfServiceDialog.vue?vue&type=template&id=093c3f54&"
import script from "./ConfirmTermsOfServiceDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmTermsOfServiceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
